import { Controller } from 'react-hook-form';

import { Select } from '../Select';

export const SelectController = ({
  control,
  name,
  handleChange,
  ...selectProps
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <Select
          value={value}
          onChange={e => {
            onChange(e);
            handleChange?.(e);
          }}
          error={Boolean(error)}
          errorMessage={error?.message}
          {...selectProps}
        />
      )}
    />
  );
};
